import { css } from '@emotion/react';
import { tokens, applyFont } from '@domain-group/fe-brary';

export const addressContainer = css`
  color: ${tokens.colors.neutral.heavy.default};
  vertical-align: middle;
  ${applyFont(tokens.typography.body)}
  margin-bottom: ${tokens.spacing.xs};

  svg {
    height: 20px;
    width: 20px;
    vertical-align: text-bottom;
  }
`;

export const address = css`
  text-decoration: underline;
`;
